'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagEcAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.22869e-06 0C9.33334 0 18.6667 -8.3689e-05 28 8.88109e-06V20C18.6667 20 9.33333 20 0 20C0 13.3333 -4.01451e-05 6.66667 6.22869e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 14.6667H28V9.33333H0V14.6667Z",
          fill: "#0748AE"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.3334 10.1335C11.3334 9.85471 11.3762 9.58592 11.4555 9.33333H0L6.22869e-06 0L28 8.88109e-06V9.33333H16.5446C16.6239 9.58592 16.6667 9.85471 16.6667 10.1335C16.6667 11.6062 15.4728 12.8002 14 12.8002C12.5273 12.8002 11.3334 11.6062 11.3334 10.1335ZM12.8444 9.33333L13.3334 10.8002H14.6667L15.1556 9.33333H12.8444Z",
          fill: "#FFD935"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V14.6667H0V20Z",
          fill: "#DE2035"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 7.33333L14.6667 10.6667H13.3333L14 7.33333Z",
          fill: "#5FC0DC"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.5613 5.01711C12.681 4.97718 12.8131 5.00835 12.9024 5.09763L14 6.19526L15.0976 5.09763C15.1869 5.00835 15.319 4.97718 15.4387 5.01711L17.4387 5.68377C17.6134 5.74199 17.7078 5.93076 17.6496 6.10541C17.5913 6.28006 17.4026 6.37444 17.2279 6.31623L15.4234 5.71471L14.2357 6.90237C14.1732 6.96488 14.0884 7 14 7C13.9116 7 13.8268 6.96488 13.7643 6.90237L12.5766 5.71471L10.7721 6.31623C10.5974 6.37444 10.4087 6.28006 10.3504 6.10541C10.2922 5.93076 10.3866 5.74199 10.5613 5.68377L12.5613 5.01711Z",
          fill: "#806428"
        }
      )
    ]
  }
);
const VpFlagEcAsset = forwardRef(FlagEcAsset);

export { VpFlagEcAsset as default };
